import React, {Component} from 'react';
import { connect } from 'react-redux';
import { API_URL } from '../../config/apiEndpoints';
import { Link } from 'react-router-dom';
import {slugify} from '../../helpers/general.helper';

class RatingsCarouselItem extends Component {

    render() {
        return (
            
            <div className="ticket-carousel-item">
                <Link to={`/film/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} >
                    <img src={API_URL + this.props.card.film_poster} alt="Bilet"/>
                </Link>
                <div className="ticket-details">
                    <Link to={`/film/${this.props.card.film_id}/${slugify(this.props.card.film_title)}`} className="white-text">
                        <span className="ticket-title db">{ this.props.card.film_translated_title } <span>({ this.props.card.film_release_year })</span></span>
                    </Link>
                    <span className="ticket-translation db grey-text">{this.props.card.film_title}</span>
                    <div className="tkts icon-rating active float-left">&nbsp;</div>
                    <div className="float-left ticket-dtls">
                        <span className="bold rating-nr">{this.props.card.my_rating}</span>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});
export default connect(mapStateToProps, {})(RatingsCarouselItem);





// WEBPACK FOOTER //
// ./src/SHARED/components/ratingscarouselitem/ratingscarouselitem.component.js